package uz.ferro.erp.model

import kotlinx.serialization.Serializable

@Serializable
data class DictItem(
    val id: Long? = null,
    val textDefault: String? = null,
    val textUzLat: String? = null,
    val textUzCyr: String? = null,
    val textRu: String? = null,
    val textEn: String? = null
)
